import { formatInrTwoDecimals } from "../../config/functions";

type Props = {
  show: boolean;
  label?: string;
  amount: number;
};

/** Shown above report tables after Search; amount matches PDF/CSV grand total. */
const ReportGrandTotalBar = ({
  show,
  label = "Grand Total",
  amount,
}: Props) => {
  if (!show) return null;

  return (
    <div className="mt-2 mb-2 p-3 bg-light border rounded-3 d-flex flex-wrap justify-content-between align-items-center gap-2">
      <span className="fw-bold">{label}</span>
      <span className="fw-bold fs-5">{formatInrTwoDecimals(amount)}</span>
    </div>
  );
};

export default ReportGrandTotalBar;
